import { Modal, Button, message } from 'antd'
import React from 'react'
import handle from 'services/Axios'
import SWR_KEY from 'services/swr/constant'
import { usePaymentStore } from 'state/usePaymentStore'
import useSWRMutation from 'swr/mutation'
import { useTranslation } from 'translations'

const DeletePaymentModal = ({ open, onCancel }) => {
	const { t } = useTranslation()

	const deletePayment = usePaymentStore((s) => s.deletePayment)
	const paymentList = usePaymentStore((s) => s.paymentList)
	const setSelectedPayment = usePaymentStore((s) => s.setSelectedPayment)

	const { trigger: handleDelete, isMutating: loadingDelete } = useSWRMutation(
		[SWR_KEY.DELETE_PAYMENT, open],
		async ([url, id], { arg }) => {
			try {
				await handle.post(url + '/' + id, arg)
				if (!paymentList || paymentList?.length === 1) setSelectedPayment(null)
				deletePayment(+(id as number))
				message.success("Delete Successfully")
				onCancel()
			} catch (error: any) {
				message.error(error.message)
			}
			return
		},
	)

	return (
		<Modal
			centered
			open={!!open}
			footer={false}
			onCancel={onCancel}
		>
			<div className="flex flex-col items-center gap-4 py-6">
				<p className="text-center font-bold text-lg">
					{t("Do you want delete this recipient?")}
				</p>

				<div className="flex items-center gap-3 w-full">
					<Button variant="outlined" size='large' className='flex-1' onClick={onCancel}>
						{t("Cancel")}
					</Button>
					<Button
						type="primary"
						size='large'
						className='flex-1'
						loading={loadingDelete}
						onClick={() => open && handleDelete()}
					>
						{t("Confirm")}
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default DeletePaymentModal